module.exports = __webpack_public_path__ + "img/08782548000576.e63792c9.png";